import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "components/Button";
import { ROUTES } from "shared/constants/routes";
import COLORS from "shared/constants/colors";
import { ContinueShoppingWrap } from "styles/pages/dtf-transfers/checkout";

const ContinueShoppingButton = ({ fullWidth = false, showDivider = true }) => {
  const navigate = useNavigate();

  const button = (
    <Button
      title="Continue Shopping"
      onClick={() => navigate(ROUTES.DTF_TRANSFERS_BY_SIZE.LINK)}
      containerStyle={{
        backgroundColor: COLORS.WHITE,
        color: COLORS.BLUE,
        border: `1px solid ${COLORS.BLUE}`,
        textTransform: "none",
        borderRadius: "6px",
        padding: "12px 20px",
        fontSize: fullWidth ? "16px" : "15px",
        width: fullWidth ? "100%" : "fit-content",
        boxShadow: "none",
      }}
    />
  );

  if (!showDivider) {
    return button;
  }

  return <ContinueShoppingWrap>{button}</ContinueShoppingWrap>;
};

export default ContinueShoppingButton;
